import Axios from '@/api/http'
import { baseurl, yqfkurl } from '../common.js'
/**
 * 获取短信验证码接口
 * phone 手机号, captchatoken 验证码token, captcha图形验证码； 返回值：data为6位数字
 * */
export function mobileGetpasswordvalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getpasswordvalidcode',
    data: query,
    promise: '1',
    baseURL: yqfkurl()
  })
}

/**
 * 验证短信验证接口
 * phone 手机号,validcode 验证码, captchatoken 验证码token, captcha图形验证码; 返回值：code=0时data为用户名数组
 * */
export function openapiValidpasswordcode (query) {
  return Axios({
    method: 'post',
    url: '/openapi/validpasswordcode',
    data: query,
    promise: '1',
    baseURL: baseurl()
  })
}

/**
 * 修改密码
 * phone 手机号，username 用户名，validcode 验证码, captchatoken 验证码token, captcha 图形验证码，password 新密码
 * */
export function openapiUpdatepassword (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updatepassword',
    data: query,
    promise: '1',
    baseURL: baseurl()
  })
}

/**
 * 绑定手机获取短信验证码接口
 * phone 手机号, captchatoken 验证码token, captcha图形验证码； 返回值：data为6位数字
 * */
export function mobileGetuserinfovalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getuserinfovalidcode',
    data: query,
    baseURL: baseurl()
  })
}

/**
 * 绑定手机接口
 * phone 手机号，validcode 验证码, captchatoken 验证码token, captcha 图形验证码
 * */
export function openapiUpdatephone (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updatephone',
    data: query,
    baseURL: baseurl()
  })
}

/**
 * 首次登陆 修改密码
 * cpassword  opassword
 * */
export function apiUpdatemine (query, promise) {
  return Axios({
    method: 'post',
    url: '/api/updatemine',
    data: query,
    promise: promise
  })
}

/**
 * 验证手机号是否已经被绑定
 * phone
 * */
export function apiCheckuser (query) {
  return Axios({
    method: 'post',
    url: '/api/checkuser',
    data: query,
    baseURL: baseurl()
  })
}
/**
 * 注册获取短信
 */
export function getregvalidcode(query) {
  return Axios({
    method: 'post',
    url: '/mobile/getregvalidcode',
    data: query
  })
}

/**
 * 验证短信验证码是否正确
 */
export function validsmsregcode(query) {
  return Axios({
    method: 'post',
    url: '/openapi/validsmsregcode',
    data: query
  })
}

/**
 * 外网注册
 */
export function registeruser(query) {
  return Axios({
    method: 'post',
    url: '/out/registeruser',
    data: query
  })
}

/**
 * 获取密码安全设置
 */
export function getoutregistercode(query) {
  return Axios({
    method: 'post',
    url: '/out/getoutregistercode',
    data: query
  })
}

/**
 * 新版滑块获取短信验证码接口
 * 参数1：moveLength   2：imagecaptchatoken   3：phone 返回值：data为6位数字
 * */
export function mobileGetpasswordsmsvalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getpasswordsmsvalidcode',
    data: query,
    promise: '1',
    baseURL: yqfkurl()
  })
}

/**
 * 新版滑块验证短信验证接口
 * 参数1：phone    2：validcode    3:imagecaptchatoken   4:moveLength 返回值：code=0时data为用户名数组
 * */
export function openapiValidsliderpasswordcode (query) {
  return Axios({
    method: 'post',
    url: '/openapi/validsliderpasswordcode',
    data: query,
    promise: '1',
    baseURL: baseurl()
  })
}

/**
 * 新版滑块修改密码
 * 重置密码 1：username  2:phone   3:imagecaptchatoken   4:moveLength  5:password  6：validcode 验证码
 * */
export function openapiResetpassword (query) {
  return Axios({
    method: 'post',
    url: '/openapi/resetpassword',
    data: query,
    promise: '1',
    baseURL: baseurl()
  })
}

/**
 * 新版滑块绑定手机获取短信验证码接口
 * 参数1：moveLength   2：imagecaptchatoken   3：phone
 * */
export function mobileGetuserinfosmsvalidcode (query) {
  return Axios({
    method: 'post',
    url: '/mobile/getuserinfosmsvalidcode',
    data: query,
    baseURL: baseurl()
  })
}

/**
 * 新版滑块绑定手机接口
 * 参数1：phone    2：validcode    3:imagecaptchatoken   4:moveLength
 * */
export function openapiBindphone (query) {
  return Axios({
    method: 'post',
    url: '/openapi/bindphone',
    data: query,
    baseURL: baseurl()
  })
}

/**
 * 获取用户学校列表
 * */
export function getuserschoollist (query) {
  return Axios({
    method: 'post',
    url: '/out/getuserschoollist',
    data: query
  })
}

/**
 * 外网注册获取安全策略配置
 * */
export function getoutpwdconfig (query) {
  return Axios({
    method: 'post',
    url: '/out/getoutpwdconfig',
    data: query
  })
}